import DrawerSectionEcho from './DrawerSectionEcho';
import { LevelOfDetail } from '@/types';
import { Radio } from 'antd';

interface LevelOfDetailSectionProps {
  selectedLevelOfDetails: LevelOfDetail;
  setSelectedLevelOfDetails: (value: LevelOfDetail) => void;
}

const LEVEL_OF_DETAIL_OPTIONS = [
  { label: 'Total for the full period only', value: LevelOfDetail.total },
  { label: 'Daily totals', value: LevelOfDetail.daily },
  { label: 'Weekly totals', value: LevelOfDetail.weekly },
  { label: 'Monthly totals', value: LevelOfDetail.monthly },
];

const LevelOfDetailSection = ({
  selectedLevelOfDetails,
  setSelectedLevelOfDetails,
}: LevelOfDetailSectionProps) => {
  const handleClick = (value: LevelOfDetail) => {
    setSelectedLevelOfDetails(value);
  };

  return (
    <DrawerSectionEcho title="Level of detail">
      <Radio.Group
        vertical
        size="large"
        options={LEVEL_OF_DETAIL_OPTIONS}
        onChange={(option) => handleClick(option.target.value)}
        value={selectedLevelOfDetails}
      />
    </DrawerSectionEcho>
  );
};

export default LevelOfDetailSection;
